import { useQuery, UseQueryResult } from 'react-query';
import { KiloClassTypeRetrieve } from 'types';
import { client } from 'utils/api-client';

function useClassType(classTypeId: string | undefined): UseQueryResult<{ data: KiloClassTypeRetrieve }> {
  return useQuery(['classType', classTypeId], () => client.get(`kilo-class-types/${classTypeId}/`), {
    enabled: !!classTypeId,
  });
}

export default useClassType;
